import type { Profile } from "./types";

const riskyFields: Array<keyof Pick<Profile, "phone" | "website" | "address" | "city" | "state" | "zipCode">> = [
  "phone",
  "website",
  "address",
  "city",
  "state",
  "zipCode",
];

export const SAFE_PUBLISH_WARNING =
  "Este campo está vazio. Antes de preencher, confirme que deseja publicar essa informação, pois a remoção automática pode não estar disponível pela integração atual.";

export const hasNewRiskyPublishedValue = (original: Profile, updated: Profile) =>
  riskyFields.some((field) => !original[field]?.trim() && Boolean(updated[field]?.trim()));
